import { useEffect, useState } from 'react';

import { NO_FEATURES, NO_LIMITS, getServerFeatures, getServerLimits } from '../services/serverFeatures';

/**
 * The server's feature switches (services/serverFeatures.js), asked ONCE when
 * the caller mounts. Until the answer lands — and when it never does — every
 * feature is `null` (unknown), so a caller that offers a feature only on `true`
 * offers nothing for a beat rather than something that may not work.
 *
 *   { features: { repeatingGroups: true | false | null }, ready: boolean }
 */
export default function useServerFeatures() {
	const [state, setState] = useState({ features: NO_FEATURES, ready: false });
	useEffect(() => {
		let live = true;
		getServerFeatures().then((features) => {
			if (live) setState({ features, ready: true });
		});
		return () => { live = false; };
	}, []);
	return state;
}

/**
 * The contract's numeric limits (services/serverFeatures.js `getServerLimits`),
 * asked once when the caller mounts, in the same request the switches use.
 * `relatedListsPerCard` is null until the answer lands and when the contract
 * does not carry it; the caller falls back to its own default.
 */
export function useServerLimits() {
	const [limits, setLimits] = useState(NO_LIMITS);
	useEffect(() => {
		let live = true;
		getServerLimits().then((next) => { if (live) setLimits(next); });
		return () => { live = false; };
	}, []);
	return limits;
}
